import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import {useDebouncedCallback} from "use-debounce";
import {TextRow, TextToolTip} from "../table";
import {MinLoader} from "../loaders";
import {limit, SavePage, SaveParams} from "utils";
import {Svg} from "assets";
import {handleSelectSort} from "./constants";
import {MenuTool} from "./menu";

export const SearchAndFilerFull = ({
                                       width,
                                       item,
                                       loader,
                                       list,
                                       searched,
                                       setSearched,
                                       generateTable,
                                   }) => {
    const [backSearched, setBackSearched] = useState({
        searchKey: "",
        searchValue: "",
    });
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const itemName = item?.name ? item?.name : null
    const active =
        info?.[item?.name] === itemName ? true :
            info?.hasOwnProperty(itemName) ? true :
                info?.sortType === itemName ? true
                    : !!searched?.[itemName] || (backSearched?.searchKey === item?.searchKey && backSearched?.searchValue);

    useEffect(() => {
        if (info?.searchKey) {
            setBackSearched({
                searchKey: info?.searchKey,
                searchValue: info?.searchValue,
            });
        } else {
            setBackSearched({
                searchKey: "",
                searchValue: "",
            });
        }
    }, [info]);




    const debounced = useDebouncedCallback(
        (name, value, searchKey) => {
            const params = {
                ...info,
            };
            params.limit = limit;
            params.skip = 0;
            params.page = 1;
            if (value) {
                params.searchKey = searchKey;
                params.searchValue = value;
            } else {
                delete params.searchKey;
                delete params.searchValue;
            }
            SaveParams(location?.pathname, navigate, params);
        },
        1000,
        {maxWait: 2000},
    );

    const handleSearch = (e, nameRow, searchKey, type) => {
        if (searchKey) {
            setBackSearched({
                searchKey: searchKey,
                searchValue: e.target.value,
            });
            debounced(e.target.name, e.target.value, searchKey);
        } else {
            setSearched(prev => ({
                ...prev,
                [e.target.name]: e.target.value,
            }));
        }
    };

    const handleClickSort = (name) => {
        if (item?.custom !== false) {
            const anotherInfo = {
                ...info,
            };
            anotherInfo.sortType = name;

            const checkForASC = !anotherInfo?.orderType || (anotherInfo?.orderType && info?.sortType !== name);

            if (checkForASC) {
                anotherInfo.orderType = "ASC";
            } else if (anotherInfo?.orderType === "ASC") {
                anotherInfo.orderType = "DESC";
            } else {
                delete anotherInfo.orderType;
                delete anotherInfo.sortType;
            }
            SavePage(navigate, info, {...anotherInfo});
        }
    };

    const handleFilter = (e) => {
        handleSelectSort(e, navigate, info);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
    };

    return (
        <div className="search-and-filer-box">
            <div
                className={active ? "active-box" : "passive-box"}
                style={width ? {width: width} : {}}
            >
                {!item?.filterList && (
                    <div
                        onClick={() => handleClickSort(item?.name)}
                        className="search-input-title"
                        style={{
                            cursor: item?.custom !== false ? "pointer" : "default",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <TextToolTip
                            classNameText="search-and-filer-text"
                            text={item?.title}
                            content={item?.title}
                        />
                        {item?.custom !== false && (
                            <div
                                className={
                                    generateTable ? "sort-btn-box-generate" : "sort-btn-box"
                                }
                                style={
                                    info?.orderType && info?.sortType === item?.name
                                        ? {opacity: 1}
                                        : {opacity: 0.6}
                                }
                            >
                                {item?.iconType === "date" ? (
                                    info?.sortType === item?.name &&
                                    info?.orderType === "DESC" ? (
                                        <Svg.LatestEarliestSvg/>
                                    ) : (
                                        <Svg.LatestEarliestWhiteSvg/>
                                    )
                                ) : info?.sortType === item?.name ?
                                    info?.orderType === "DESC" ? (
                                            <Svg.SortSvgDESC/>
                                        )
                                        :
                                        (
                                            <Svg.SortSvgASC/>
                                        )
                                    :
                                    (
                                        <Svg.SortSvg/>
                                    )
                                }
                            </div>
                        )}
                    </div>
                )}

                {item?.custom !== false && item?.filterList && (
                    <MenuTool
                        item={item}
                        handleFilter={handleFilter}
                        handleClickSort={handleClickSort}
                        selectedFilter={info?.type ? info?.type : "All"}
                    />
                )}

                {!item?.noSearch && (
                    <div style={{position: "relative"}}>
                        <form autoComplete="off" onSubmit={handleSubmit}>
                            <input
                                autoComplete={"new-password"}
                                disabled={item?.disabled || !item?.name}
                                name={item?.name}
                                value={
                                    backSearched?.searchKey === item?.searchKey
                                        ? backSearched?.searchValue
                                        : searched?.[item?.name] || ""
                                }
                                // defaultValue={null}
                                // onChange={handleSearch}
                                onChange={(e) =>
                                    handleSearch(e, item?.rowName, item?.searchKey, item?.icon)
                                }
                                type="search"
                            />
                        </form>
                        {!!loader && (
                            <MinLoader
                                margin={"6px 0 0 -20px"}
                                color="rgba(166, 222, 251, 0.29)"
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
